<template>
  <div class="wf-page-content">
    <WfIcon icon="success" />
    <p>
      <strong>Ready to import</strong>
      Open your site in Webflow and launch the Figma to Webflow app to import.
    </p>
  </div>
</template>
<script>
import WfIcon from '@/components/WfIcon.vue';
export default {
  components: {
    WfIcon,
  },
};
</script>
